module.exports = __webpack_public_path__ + "static/media/216-Uebergabe_ID_7.dbfc1a45.mp3";